<template>
  <v-card :style="shipmentTypeStyle(localShipment.type)" class="planner-layout__card plannerV2 mr-1 ml-1">
    <v-card-actions class="pl-1 pr-1 pb-0 pt-1">
      <v-row class="pl-1" no-gutters>
        <v-col v-show="false" @click="deleteShipment(shipmentIndex)" cols="1" class="text-left">
          <a><v-icon :size="16" color="red">fa fa-times</v-icon></a>
        </v-col>
        <v-col cols="1" class="text-left">
          <a><v-icon :size="14">far fa-circle</v-icon></a>
        </v-col>
        <v-col @click="changeShipmentView()" cols="1" class="text-left">
            <a>
              <v-icon :size="14">
                {{sortableView === 'locations' ? 'fas fa-boxes' : 'fas fa-location-arrow'}}
              </v-icon>
              </a>
        </v-col>
         <!-- <v-flex v-show="!isShipmentLocked && shipmentAvailabilityStatus" xs1 class="text-xs-left">
            <a><v-icon :size="14">fas fa-lock</v-icon></a>
        </v-flex> -->
        <v-col offset="2" cols="5" class="text-center">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <div v-show="assigneDriver" class="custom--chip" v-on="on">
                <AssignShipmentType :chipText="assign.title" :type="'edit'" :selectDriver="selectAssign"/>
              </div>
            </template>
            <template #default>
              <v-list style="position: relative; max-height: 60px; background-color: transparent;" class="pt-1 pb-1">
                  <v-list-item>
                    <v-list-item-avatar class="mr-3" style="position: relative;">
                      <img
                        style="position: absolute; left: 0;"
                        :src="assign.avatar"
                        alt="Avatar"
                      >
                      <img
                        v-if="assign.avatar2"
                        style="position: absolute; left: 50%;"
                        :src="assign.avatar2"
                        alt="Avatar"
                      >
                    </v-list-item-avatar>
                      <v-list-item-content style="min-height: 55px;">
                        <v-list-item-title style="color: #eeeeee;">{{assign.title}}</v-list-item-title>
                        <v-list-item-subtitle style="color: #eeeeee;">{{assign.subtitle}}</v-list-item-subtitle>
                        <v-list-item-subtitle  style="color: #eeeeee;" v-if="assign.subtitle2 !== undefined">{{assign.subtitle2}}</v-list-item-subtitle>
                      </v-list-item-content>
                  </v-list-item>
                </v-list>
            </template>
          </v-tooltip>
        </v-col>
        <v-col cols="1" class="text-right pl-3">
            <v-menu
            :close-on-content-click="true"
            :nudge-width="50"
            offset-x
            :ref="`shipmentActionMenuRef${this.shipment.shipmentID}`"
            >
              <template v-slot:activator="{ on, value }">
                <v-btn
                  v-on="on"
                  small
                  depressed
                ><v-icon size="16">
                  {{ value ? 'fas fa-times' : 'fas fa-ellipsis-h' }}
                  </v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item>
                  <template #default>
                    <a class="body-1 font-weight-bold d-inline">
                      <AssignShipmentType :handleCloseMenu="closeActionMenu" :type="'add'" :selectDriver="selectAssign"/>
                    </a>
                  </template>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item
                v-if="computedIsShipmentDeletable"
                 class="red"
                >
                  <v-list-item-content
                  >
                    <a @click="handleDeletePlannerShipment" class="body-1 font-weight-bold d-inline">
                      <span class="white--text">{{$t('planner.delete')}}</span>
                    </a>
                  </v-list-item-content>
                </v-list-item>
                <!-- <v-list-item>
                  <v-list-item-content>
                    <a @click="handleSaveShipment" class="body-1 font-weight-bold d-inline">
                      <span>save</span>
                    </a>
                  </v-list-item-content>
                </v-list-item> -->
                <v-divider></v-divider>
                <v-list-item>
                  <v-list-item-content>
                    <a
                    class="body-2
                    font-weight-bold d-inline"
                    @click="handleOptimizePlannerShipment"
                    >
                      <span>{{$t('planner.optimize')}}</span>
                    </a>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
        </v-col>
      </v-row>
    </v-card-actions>
    <v-card-title
    style="margin-top: -10px"
    class="pt-0 pb-0 pl-1 pr-1"
    >
      <v-container
        class="pa-0"
      >
        <v-row
        class="planner-layout__card--shipments--title text-center"
        no-gutters
        align="start"
        >
          <v-col
              cols="12"
              class="wrapper-card--label"
            >
            <template
              v-if="shipmentLabels != null"
            >
              <span
              v-for="(label, index) in shipmentLabels"
              :key="index"
              class="card--label"
              :class="[index === 0 && shipmentLabels.length > 1 ? 'label-green' : 'label-purple']"
              >
                {{label}}
              </span>
            </template>
            </v-col>
          <v-col cols="3">
            <div class="d-flex flex-column align-center">
              <span class="wrld_title--text caption font-weight-bold">
                  {{computeShipmentInfo.weight | roundValueWeight(0)}} kg
              </span>
              <span class="wrld_subtitle--text caption font-weight-bold">{{$t('planner.weight')}}</span>
            </div>
          </v-col>
          <v-col cols="3">
            <div class="d-flex flex-column align-center">
              <span class="wrld_title--text caption font-weight-bold">
                  {{computeShipmentInfo.volume | roundValue(1)}} m³
              </span>
              <span class="wrld_subtitle--text caption font-weight-bold">
                {{$t('planner.volume')}}
              </span>
            </div>
          </v-col>
          <v-col class="planner-layout__card--shipments--title--info" cols="3">
            <div class="d-flex flex-column align-center">
              <span class="wrld_title--text caption font-weight-bold">
                  {{computeTotalDistance | filterDistance}}
              </span>
              <span class="wrld_subtitle--text caption font-weight-bold">
                {{$t('planner.distance')}}
              </span>
            </div>
          </v-col>
          <v-col cols="3">
            <div class="d-flex flex-column align-center">
              <span class="wrld_title--text caption font-weight-bold">
                  {{ computeTotalDuration | filterDuration }}
              </span>
              <span class="wrld_subtitle--text caption font-weight-bold">
                {{$t('planner.duration')}}
              </span>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-card-title>
    <v-divider></v-divider>
    <v-row v-show="false" class="planner-layout__card--locations overflow-y-auto" no-gutters>
      <v-col cols="12" class="text-center pt-3">
        <v-progress-circular
          indeterminate
          color="light"
          size="28"
        ></v-progress-circular>
      </v-col>
    </v-row>
    <v-row no-gutters v-if="sortableView === 'locations'" class="planner-layout__card--locations overflow-y-auto sortable--drop--filtered">
      <TimeLineShipmentDrops :locations="shipmentLocations" :shipmentID="shipment.shipmentID" style="visibility: hidden; max-width: 0;" v-if="false" />
      <ScheduleShipmentDrops :shipmentID="shipment.shipmentID"  />
      <v-col class="sortable--drop--filtered fill-height" cols="8">
        <v-row class="sortable--drop--filtered fill-height" no-gutters>
          <v-col :id="`${shipment.shipmentID}_schedule`" :class="[`draggable_list_shipment_${shipment.shipmentID}`, shipmentLocations.length > 0 ? 'col-12' : 'col-12 minHeight']">
            <template v-for="(location, index) in shipmentLocations">
              <DropLocationItem
              :key="`card_${location.locationID}_${location.locationType}_${index}`"
              class="pa-1"
              :locationIndex="index === (shipmentLocations.length - 1) ? -1 : index" :location-hash="`${location.shipmentID}||${location.locationID}||${location.locationType}`"
              :locationID="location.locationID"
              :card="location"
              :class="{'sortable--drop--filtered': location.locationType === 'Depot'}"
              />
            </template>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row no-gutters v-if="sortableView === 'drops'" class="planner-layout__card--locations overflow-y-auto">
        <v-col :id="`${shipment.shipmentID}_backlog`" :class="[`draggable_list_shipment_${shipment.shipmentID}_backlog`, 'col-12 minHeight']">
          <template v-for="(drop, index) in computeShipmentDrops">
            <DropCompactItem
            class="noselect"
            :removeButton="true"
            :removeFunction="removeDrop.bind(null, drop, index)"
            :data-id="drop"
            :shipment-id="shipment.shipmentID"
            :dropID="drop"
            :key="drop"
            :route="route"
            @drop:info="handleOpenInfo"
            />
          </template>
        </v-col>
    </v-row>
    <DropTransportsInfo :isOpen="dropInfoDialog" :dropID="dropInfoDropID" @close="dropInfoDialog = false" />
  </v-card>
</template>
<script>
import DropLocationItem from '@/components/planner/DropLocationItem.vue'
import TimeLineShipmentDrops from '@/components/planner/TimeLineShipmentDrops.vue'
import DropCompactItem from '@/components/planner/DropCompactItem.vue'
import AssignShipmentType from '@/components/planner/AssignShipmentType.vue'
import DropTransportsInfo from '@/components/planner/DropTransportsInfo.vue'
import ScheduleShipmentDrops from '@/components/planner/ScheduleShipmentDrops.vue'
import { mapActions, mapGetters } from 'vuex'
import { plannerService } from '@/_services'
import { generalHelpers, plannerHelpers } from '@/_helpers'
import { getUsernameUUID } from '@/_services/amplify.service'
import Sortable from 'sortablejs'
// import moment from 'moment-timezone'
export default {
  name: 'SortableInstanceShipmentDrops',
  components: {
    DropLocationItem,
    TimeLineShipmentDrops,
    DropCompactItem,
    AssignShipmentType,
    DropTransportsInfo,
    ScheduleShipmentDrops
  },
  props: {
    shipment: Object,
    shipmentIndex: String,
    handleDeleteShipment: Function
  },
  data () {
    return {
      shipmentSceduleSortableInstance: null,
      sortableSceduleElement: null,
      shipmentDropsSortableInstance: null,
      sortableDropsElement: null,
      arrayOfDateTimes: [],
      assigneDriver: false,
      assign: {},
      localShipment: { labels: ['George', '30-08-2019', '1PL', 'I am little long long long long label'] },
      sortableView: 'drops',
      hover: false,
      currentUser: null,
      dropInfoDialog: false,
      dropInfoDropID: null,
    }
  },
  mounted () {
    this.localShipment = { ...this.localShipment, ...this.shipment }
    this.$nextTick(() => {
      this.initializeSortableDropsInstance()
    })
  },
  methods: {
    ...mapActions({
      initializeShipmentAutomergeDoc: 'initializeShipmentAutomergeDoc',
      changeEventShipmentAutomergeDoc: 'changeEventShipmentAutomergeDoc',
      movePlannerLocationCard: 'movePlannerLocationCard',
      movePlannerDropCard: 'movePlannerDropCard',
      movePlannerDropCardToBackLog: 'movePlannerDropCardToBackLog',
      deletePlannerShipment: 'deletePlannerShipment',
      optimizePlannerShipment: 'optimizePlannerShipment',
      setPlannerTimeLineLocations: 'setPlannerTimeLineLocations',
      plannerSetDropTransport: 'plannerSetDropTransport',
      plannerSetShipmentSchedule: 'plannerSetShipmentSchedule'
    }),
    handleOpenInfo (dropID) {
      const drop = this.getPlannerDropByID(dropID)
      this.plannerSetDropTransport({ drop })
      this.dropInfoDropID = dropID
      this.dropInfoDialog = true
    },
    closeActionMenu () {
      const parentMenu = this.$refs[`shipmentActionMenuRef${this.shipment.shipmentID}`]
      parentMenu.isActive = false
    },
    initializeShipmentAction () {
      getUsernameUUID().then(({ usernameUUID }) => {
        this.initializeShipmentAutomergeDoc({ shipmentID: this.shipmentIndex, drops: this.planner.drops, userID: usernameUUID })
        this.currentUser = usernameUUID
      })
    },
    // Schedule Sortable
    initializeSortableScheduleInstance () {
      this.sortableSceduleElement = document.querySelector(`.draggable_list_shipment_${this.shipment.shipmentID}`)
      const _self = this
      if (_self.shipmentSceduleSortableInstance != null) {
        _self.shipmentSceduleSortableInstance.destroy()
        _self.shipmentScheduleSortableInstance = null
      }
      this.shipmentSceduleSortableInstance = new Sortable(_self.sortableSceduleElement, {
        group: {
          name: 'planner',
          pull: function (to, from) {
            return to.el.id.indexOf(_self.shipment.shipmentID) >= 0
          },
          put: function (to, from) {
            return to.el.id.indexOf(_self.shipment.shipmentID) >= 0
          },
        },
        filter: '.sortable--drop--filtered',
        ghostClass: 'drop-ghost',
        chosenClass: 'drop-ghost',
        forceFallback: true,
        dataIdAttr: 'data-id',
        // fallbackTolerance: 5,
        animation: 150,
        fallbackOnBody: true,
        removeOnSpill: false,
        store: {
          get: (sortable) => {
          },
          set: (sortable) => {
          }
        },
        onAdd: ({ item, to, from, dragged, newIndex, oldIndex }) => {
          _self.movePlannerDropCard({
            doc: _self.getPlannerDoc,
            newIndex,
            newShipmentID: _self.shipment.shipmentID,
            oldShipmentID: item.getAttribute('shipment-id'),
            dropID: item.getAttribute('data-id'),
            drop: _self.getPlannerDropByID(item.getAttribute('data-id'))
          })
        },
        onUpdate: ({ item, to, from, dragged, newIndex, oldIndex }) => {
          if (item.getAttribute('location-hash') != null) {
            _self.movePlannerLocationCard({
              doc: _self.getPlannerDoc,
              hashKey: item.getAttribute('location-hash'),
              newIndex,
              oldIndex
            })
          }
        },
        onMove: ({ dragged, to }, { target }) => {
          if (
            to.getAttribute('id').indexOf(_self.shipment.shipmentID) >= 0
            &&
            target.getAttribute('location-hash').indexOf('Depot') === -1
            ) {
            return true
          } else {
            return false
          }
        },
        onEnd: ({ item, to, dragged, newIndex }) => {
          if (to.getAttribute('id') !== `${this.shipment.shipmentID}`) {
            // item.parentNode.removeChild(item)
          }
        }
      })
    },
    initializeSortableDropsInstance () {
      this.sortableDropsElement = document.querySelector(`.draggable_list_shipment_${this.shipment.shipmentID}_backlog`)
      const _self = this
      if (_self.shipmentDropsSortableInstance != null) {
        _self.shipmentDropsSortableInstance.destroy()
        _self.shipmentDropsSortableInstance = null
      }
      this.shipmentDropsSortableInstance = new Sortable(_self.sortableDropsElement, {
        group: {
          name: 'planner',
          put: ['planner'],
          pull: function (to, from) {
            return to.el.id.indexOf('backlog') >= 0 || to.el.id.indexOf('schedule') > 0
          },
        },
        delay: 50,
        filter: '.sortable--drop--filtered',
        ghostClass: 'drop-ghost',
        chosenClass: 'drop-ghost',
        forceFallback: true,
        // fallbackClass: 'force-fallback-class',
        dataIdAttr: 'data-id',
        fallbackTolerance: 5,
        animation: 150,
        fallbackOnBody: false,
        removeOnSpill: false,
        store: {
          get: (sortable) => {
          },
          set: (sortable) => {
          }
        },
        onAdd: ({ item, to, from, dragged, newIndex, oldIndex }) => {
          _self.movePlannerDropCard({
            doc: _self.getPlannerDoc,
            newIndex,
            newShipmentID: _self.shipment.shipmentID,
            oldShipmentID: item.getAttribute('shipment-id'),
            dropID: item.getAttribute('data-id'),
            drop: _self.getPlannerDropByID(item.getAttribute('data-id'))
          })
        },
        onMove: ({ dragged, to }) => {
        },
        onEnd: ({ item, to, dragged, newIndex }) => {
          if (to.getAttribute('id') !== `${this.shipment.shipmentID}_backlog`) {
            // item.parentNode.removeChild(item)
          }
        }
      })
    },
    /**
     * Add label to a shipment
     */
    addNewLabel (label) {
      this.localShipment.labels.push(label)
    },
    /**
     * Remove label from a shipment
     */
    removeLabel (labelIndex) {
      this.localShipment.labels.splice(labelIndex, 1)
    },
    selectAssign (assign) {
      this.assigneDriver = true
      this.localShipment.type = assign.type
      this.assign = { ...assign }
    },
    // Change shipment view between locations and drops
    changeShipmentView () {
      this.sortableView = this.sortableView === 'locations' ? 'drops' : 'locations'
    },
    // Remove drop from shipment
    removeDrop (drop, index) {
      this.movePlannerDropCardToBackLog({
        doc: this.getPlannerDoc,
        oldShipmentID: this.shipment.shipmentID,
        dropID: drop
      })
    },
    deleteShipment (index) {
      this.handleDeleteShipment(index, this.localShipment)
    },
    editAssigment () {
      this.hover = !this.hover
    },
    shipmentTypeStyle (type) {
      let color = 'grey'
      switch (this.shipment.type) {
        case '1PL':
          color = '#4CAF50'
          break
        case '2PL':
          color = '#2196F3'
          break
        default:
          break
      }
      return 'border-top: 2px ' + color + ' solid;'
    },
    handleSaveShipment () {
      plannerService.plannerSaveShipment({ shipmentID: this.shipment.shipmentID, docID: this.shipment.docID }).then((response) => {
        console.log(response)
      })
    },
    handleDeletePlannerShipment () {
      this.deletePlannerShipment({ doc: this.getPlannerDoc, shipmentID: this.localShipment.shipmentID })
    },
    handleOptimizePlannerShipment () {
      const dropIDs = this.getPlannerDropsByShipmentID(this.localShipment.shipmentID)
      this.optimizePlannerShipment({ doc: this.getPlannerDoc, shipmentID: this.localShipment.shipmentID, drops: this.getPlannerDropsByArrayIDs(dropIDs) })
    }
  },
  computed: {
    ...mapGetters([
      'getPlannerDoc',
      'getPlannerCardsByShipments',
      'getPlannerDrops',
      'getPlannerDropsByShipmentID',
      'getPlannerDropByID',
      'getPlannerCalculateRoutes',
      'getPlannerShipmentByID',
      'getPlannerDropsByArrayIDs',
      'getPlannerTimelineByID',
      'getPlannerShipment',
      'getPlannerScheduleDistance',
      'getPlannerScheduleDuration',
      'getPlannerDropsObjectByShipmentID'
    ]),
    shipmentLabels () {
      const shipment = this.getPlannerShipment(this.shipment.shipmentID)
      if ( shipment != null) {
        if (shipment.status != null && shipment.labels != null) {
          return [...shipment.labels, ...[shipment.status]]
        } else if (shipment.labels != null) {
          return [...shipment.labels]
        } else if (shipment.status != null) {
          return [shipment.status]
        } else {
          return []
        }
      }
      return []
    },
    shipmentLocations () {
      if (this.sortableView === 'drops') {
        // const locations = this.getPlannerCardsByShipments(this.shipment.shipmentID)
        // let timeline = []
        // for (let index = 0; index < (locations.length - 1); index++) {
        //   timeline.push([locations[index].locationID, locations[index + 1].locationID])
        // }
        //  let missingTimeLines = []
        //   timeline.forEach((location) => {
        //     if (this.getPlannerTimelineByID(`${location[0]}||${location[1]}`) === null) {
        //       missingTimeLines.push(location)
        //     }
        //   })
        //   if (missingTimeLines.length > 0) {
        //     this.setPlannerTimeLineLocations({ timeline: timeline })
        //   }
        // plannerHelpers.plannerCalculateRoute({ timelineArrays: timeline, docDay: this.$route.query.day })
      }
      return this.getPlannerCardsByShipments(this.shipment.shipmentID)
    },
    computeShipmentDrops () {
      return this.getPlannerDropsByShipmentID(this.shipment.shipmentID)
    },
    computeShipmentInfo: function () {
      let weight = 0
      let volume = 0
      this.computeShipmentDrops.forEach((dropID) => {
        const drop = this.getPlannerDropByID(dropID)
        if (drop.weight != null) {
          weight += Number(drop.weight)
        }
        if (drop.volume != null) {
          volume += Number(drop.volume)
        }
      })

      return { weight, volume }
    },
    computeTotalDistance () {
      return this.getPlannerScheduleDistance(this.localShipment.shipmentID)
    },
    computeTotalDuration () {
      return this.getPlannerScheduleDuration(this.localShipment.shipmentID)
    },
    computedIsShipmentDeletable () {
      const shipmentDocObject = this.getPlannerShipmentByID(this.localShipment.shipmentID)
      if (shipmentDocObject != null) {
        return shipmentDocObject.isPlannerShipment && this.shipmentLocations.length < 1
      }
      return false
    },
    route () {
      return plannerHelpers.plannerCalculateRoute({ shipmentLocations: this.shipmentLocations, docDay: this.$route.query.day })
    }
  },
  watch: {
    sortableView: {
      handler (val, oldVal) {
        if (val === 'drops') {
          this.shipmentScheduleSortableInstance = null
          this.$nextTick(() => {
            this.initializeSortableDropsInstance()
          })
        } else if (val === 'locations') {
          this.shipmentDropsSortableInstance = null
          this.$nextTick(() => {
            this.initializeSortableScheduleInstance()
          })
        }
      }
    },
    getPlannerDoc: {
      deep: true,
      immediate: true,
      handler (val, oldVal) {
        if (val != null && this.sortableView === 'drops') {
          this.plannerSetShipmentSchedule({ doc: val, shipmentID: this.shipment.shipmentID, drops: this.getPlannerDropsObjectByShipmentID(this.shipment.shipmentID) })
        }
      }
    }
  },
  beforeDestroy () {
    // if (this.shipmentDropsSortableInstance != null) {
    //   console.log(this.shipmentDropsSortableInstance)
    //   this.shipmentDropsSortableInstance.destroy()
    // }
    // if (this.shipmentSceduleSortableInstance != null) {
    //   console.log(this.shipmentScheduleSortableInstance)
    //   this.shipmentSceduleSortableInstance.destroy()
    // }
  }
}
</script>
<style lang="scss" scoped>
.drop-ghost {
    // visibility: hidden;
    opacity: 0.5;
  }
 .force-fallback-class {
   // opacity: 0.5;
   visibility: hidden;

 }

.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                        supported by Chrome, Opera and Firefox */
}
  .custom--chip{
    background-color: #028489;
    border: 0px solid;
    border-radius: 20px;
    height: 20px;
  }
.v-timeline-item {
    padding: 0;
    position: relative;
    height: 22px;
    &.dateTimeLoading {
      height: 50px;
    }
    .customTextDot {
      &.placeholderLoader {
        max-height: 10px;
        min-width: 80%;
        &.distance {
          min-width: 60%;
        }
      }
      font-size: 12px;
      font-weight: bold;
      background-color: #eeeeee;
      color: #212121;
      position: absolute;
      text-align: center;
      display: inline-block;
      left: 0;
      top: 0;
      &.loading {
        left: 2px;
      }
      &.date {
        top: 20px;
        color: #777777;
      }
      .dropCardTitle {
        &.overflowEllipsis {
          max-width: 90%;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          display: inline-block;
        }
        font-size: 12px;
        font-weight: bold;
        color: #212121;
      }
      .dropCardSubTitle {
        display: inline-block;
        font-size: 10px;
        font-weight: bold;
        color: #777777;
      }
    }
  }
  .wrapper-card--label {
    min-height: 40px;
    .card--label {
      font-size: 11px;
      font-weight: bold;
      color: #fff;
      text-align: center;
      padding: 2px 8px;
      border-radius: 20px;
      margin-right: 5px;
      margin-bottom: 1px;
      &.label-green {
        background-color: #50E898;
      }
      &.label-pink {
        background-color: #ef476f;
      }
      &.label-purple {
        background-color: #6A68CD;
      }
    }
  }
</style>
